<!--
================================================
Un composant pour créer/modifier un user

Url d'accès :
http://localhost:8080/fr/cronocloud-inc/team/users

@since 0.44.1 Les champs firstname et name sont "required" uniquement si user.IsVerified et user.lastLogin !=null. Ce changement a été implémenté suite à l'ajout de la possibilité de modifier les utilisateurs qui viennent d'être invité afin D'INCITER À LA DÉFINITION D'UNE VALEUR POUR user.hourRate


LIMITATION DU COMPOSANT :
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>

    <div class="modal" id="ModalUserManagementComp" v-on:keyup.esc="hideModal()" v-bind:class="{ 'is-active': isVisible ,'darkMode':themeToDisplay=='dark' }">
        <!--ajouter la classe is-active sur.modal pour l'afficher-->
        <div class="modal-background"></div>
        <div class="modal-card" >
            <header class="modal-card-head">
                <font-awesome-icon :icon="['fas', 'user']" class="icon"/>

                <p class="modal-card-title has-text-left">
                    <span v-if="mode== 'creation'">{{$t('InviterDesUtilisateurs')}}</span>
                    <span v-if="mode== 'edition'">{{$t('ModifierUnUtilisateur')}}</span>

                </p>
                <button v-on:click="hideModal()" id="closeModalUserManagement" class="delete" aria-label="close"></button>
            </header>
            <section class="modal-card-body">


                <!----------------------------------------------------->
                <!--------EDIT FORM ----------------------------------->
                <!----------------------------------------------------->
                <div class="formEdition" v-if="mode=='edition'">

                  <div class="warningNotYetVerified" v-if="newUser.isActive==true && newUser.isVerified !=true && newUser.lastLogin == null">
                    <font-awesome-icon class="icon" :icon="['fas', 'envelope']"/>
                    {{$t('lUtilisateurNaPesEncoreRéponduÀLInvitation')}}
                  </div>

                    <form action="" v-on:keyup.enter="validateBeforeSubmit"  v-on:submit.prevent>


                    <!--------CHAMP FIRSTNAME----------------------------------->
                    <div class="field">
                        <label style="display: none" for="modalUserManagement_firstname">{{$t('prénom')}}</label>
                        <input class="input userFirstname" type="text" v-bind:placeholder="$t('prénom')"
                               tabindex="0"
                               v-bind:disabled="newUser.isActive==false"
                               v-model="newUser.firstname"
                               v-validate="{required: newUser.isVerified && newUser.lastLogin !=null,max:80}"
                               data-vv-validate-on="change"
                               name="modalUserManagement_firstname"
                               id="modalUserManagement_firstname"
                               v-bind:class="{'is-loading':isSubmiting}"
                        >
                        <p class="help is-danger has-text-left" id="error_modalUserManagement_firstname">{{errors.first('modalUserManagement_firstname') }}</p>

                    </div>

                    <!--------CHAMP NAME----------------------------------->
                    <div class="field">
                        <label style="display: none" for="modalUserManagement_name">{{$t('nom')}}</label>
                        <input class="input userName" type="text" v-bind:placeholder="$t('nom')"
                               tabindex="0"
                               v-bind:disabled="newUser.isActive==false"
                               v-model="newUser.name"
                               v-validate="{required: newUser.isVerified && newUser.lastLogin !=null,max:80}"
                               data-vv-validate-on="change"
                               name="modalUserManagement_name"
                               id="modalUserManagement_name"
                               v-bind:class="{'is-loading':isSubmiting}"
                        >
                        <p class="help is-danger has-text-left" id="error_modalUserManagement_name">{{errors.first('modalUserManagement_name') }}</p>

                    </div>

                    <!--------CHAMP EMAIL----------------------------------->
                    <div class="field">
                        <label style="display: none" for="modalUserManagement_email">{{$t('email')}}</label>
                        <input class="input userEmail" type="text" v-bind:placeholder="$t('email')"
                               tabindex="0"
                               v-bind:disabled="newUser.isActive==false"
                               v-model="newUser.email"
                               v-validate="'required|email'"
                               data-vv-validate-on="change"
                               name="modalUserManagement_email"
                               id="modalUserManagement_email"
                               v-bind:class="{'is-loading':isSubmiting}"
                        >
                        <p class="help is-danger has-text-left" id="error_modalUserManagement_email">{{errors.first('modalUserManagement_email') }}</p>

                    </div>



                      <!--------CHAMP HOUR RATE----------------------------------->
                      <label class="label" for="modalUserManagement_hourRate">{{$t('TauxHoraireFacturable')}} ({{(currencyToSign(currency))}})</label>
                      <div class="field has-addons hourRateField">
                        <div class="control">
                          <input class="input hourRate " type="number" min="0" max="99999" v-bind:placeholder="'35 '+ currencyToSign(currency)"
                                 tabindex="0"
                                 v-bind:disabled="newUser.isActive==false"
                                 v-model="newUser.hourRate"
                                 v-validate="'required|min:0|max:99999'"
                                 data-vv-validate-on="change"
                                 name="modalUserManagement_hourRate"
                                 id="modalUserManagement_hourRate"
                                 v-bind:class="{'is-loading':isSubmiting}"
                          >

                          <p class="help is-danger has-text-left" id="error_modalUserManagement_hourRate">{{errors.first('modalUserManagement_hourRate') }}</p>
                          <p class="help" v-html="$t('PermetDeCalculerLeCoutDesTempsPassés')"></p>

                        </div>

                        <div class="control inputAddonLabel">
                          <a class="button is-static">{{$t('$parHeure', {"currency": currencyToSign(currency)})}}</a>
                        </div>


                      </div>


                    <!--------CHAMP ACCÈS (ROLE)----------------------------------->

                    <div class="field accessField">
                        <label class="label" for="">{{$t('Accès')}}</label>
                        <div class="control has-icons-left">

                            <div class="select">

                                <select v-bind:disabled="newUser.isActive==false"
                                        v-model="newUser.roles[0]" id="modalUserManagement_roles">
                                    <option v-bind:selected="getHighestRole(newUser)==rolesHierarchyList.user"
                                            v-bind:value="rolesHierarchyList.user">{{$t('Standard')}}
                                    </option>
                                    <option v-bind:selected="getHighestRole(newUser)==rolesHierarchyList.admin"
                                            v-bind:value="rolesHierarchyList.admin">{{$t("Administrateur")}}
                                    </option>
                                    <option v-bind:selected="getHighestRole(newUser)==rolesHierarchyList.owner"
                                            v-bind:value="rolesHierarchyList.owner">{{$t('Propriétaire')}}
                                    </option>

                                </select>

                            </div>


                            <div class="icon is-small is-left">
                                <font-awesome-icon :icon="['fas', 'id-badge']" class="icon"/>
                            </div>

                        </div>

                        <div class="legend">

                            <span v-show="newUser.roles==rolesHierarchyList.user" class="help">{{$t("detailAccesStandard")}}</span>
                            <span v-show="newUser.roles==rolesHierarchyList.admin" class="help">{{$t('detailAccesAdmin')}}</span>
                            <span v-show="newUser.roles==rolesHierarchyList.owner" class="help"> {{$t('detailAccesProprietaire')}}</span>

                        </div>
                    </div>

                    <!--------------------------------------------------------------->
                    <div class="columns settingsZone">


                        <!--------CHAMP ARCHIVE----------------------------------->
                        <!-- La désactivation est masqué pour soi-même (empechêche de s'auto désactiver)-->
                        <div class="column blocArchive" v-if="
                        mode=='edition' && newUser.slug != $auth.getUserSlug()">

                            <div class="field">
                                <label class="label" for="modalUserManagement_archive">{{$t('désactivation')}}</label>

                                <span id="msg_deactivation_owner" class="help is-danger" v-show="getHighestRole(newUser)==rolesHierarchyList.owner">
                                     {{$t('UnRoleProprietaireNePeutEtreDésactivé')}}
                                </span>

                                <!-- NOTE : On ne peut pas désactiver un user avec le ROLE_OWNER -->
                                <input v-on:click="toggleArchive" id="modalUserManagement_archive"
                                       v-bind:disabled="getHighestRole(newUser)==rolesHierarchyList.owner"

                                       type="checkbox" name="modalUserManagement_archive" class="switch is-medium is-rounded"
                                       v-model="newUser.isActive" checked="checked" v-bind:class="{'isArchived':newUser.isActive ==false}">
                                <label for="modalUserManagement_archive" class="archiveLabel">
                                    <!-- à afficher même vide sinon le switch n'est pas visible-->
                                    <span v-if="newUser.isActive==false" class="indicator">
                                        <font-awesome-icon  class="icon" :icon="['fas', 'user-slash']" />
                                        {{$t('UtilisateurDésactivé')}}
                                    </span>
                                    <span v-else class="indicator">
                                        <font-awesome-icon  class="icon" :icon="['fas', 'user']" />
                                        {{$t('UtilisateurActif')}}
                                    </span>

                                </label>

                                <span class="help" v-bind:class="{'is-danger': newUser.isActive==false}">
                                     <span class="has-text-weight-bold" v-if="newUser.isActive==false">{{$t('CetUtilisateurEstArchivé')}}</span>
                                    <span v-else>{{$t('CetUtilisateurEstActif')}}</span>
                                </span>

                            </div>
                        </div>

                    </div>

                    <!--//////////////////////////////////// -->

                </form>
                </div>

                <!----------------------------------------------------->
                <!--------INVIT FORM ----------------------------------->
                <!----------------------------------------------------->
                <div class="formInvit" v-if="mode=='creation'">
                    <form action=""  v-on:submit.prevent>


                        <!--------CHAMP EMAIL LIST----------------------------------->
                        <p class="help is-danger" id="warningNonVerifiedUser" v-show="user.isVerified==false">
                            {{$t('VousDevezVerifierVotreAdresseEmailAvantDInviter')}}

                        </p>

                        <div class="field">
                            <label style="display: none" for="modalUserManagement_emailList">{{$t('adressesEmail')}}</label>
                            <textarea class="textarea inviteEmailList" type="text"
                                   tabindex="0"
                                   v-model="inviteEmailList"
                                   maxlength="2732"
                                   v-bind:disabled="user.isVerified==false"
                                   data-vv-validate-on="change"
                                   name="modalUserManagement_emailList"
                                   id="modalUserManagement_emailList"
                                   v-bind:class="{'is-loading':isSubmiting}"
                                      v-on:focus="arrayEmailToInviteErrors=[]"
                            ></textarea>

                            <p class="help is-danger has-text-left" id="error_modalUserManagement_emailList">{{errors.first('modalUserManagement_emailList') }}</p>

                            <!-- Message si textearea vide -->
                            <span v-if="inviteEmailList==null && createFormHasBeenSubmited" class="help is-danger has-text-left">
                                        {{$t('VousDevezAjouterUneAdresseEmail')}}
                            </span>

                            <!-- Message erreurs validité emails -->
                            <ul class="emailValidityError">
                                <li v-for="(invalidEmail, index) in arrayEmailToInviteErrors" :key="index"
                                    v-bind:name="'modalUserManagement_email_'+index"
                                    class="is-danger has-text-left">
                                    <span class="help is-danger has-text-left">
                                        {{$t('XNEstPasValide',{"email":invalidEmail})}}
                                    </span>
                                </li>
                            </ul>

                            <!-- Message en cas d'erreur 400 (ex : email déjà existants) -->
                            <ul class="error400Response">
                                <li v-for="(apiError, name,index) in apiErrorResponse" :key="index"
                                    class="is-danger has-text-left"> <!-- name contient l'adresse email en erreur-->
                                    <span class="help is-danger has-text-left" v-if="apiError.error=='unavailable'"> <!-- (lorsque l'adresse est déjà utilisé,la description de l'erreur dans la clé 'error' vaut 'unavailable')  -->
                                        {{$t('lEmailXEstDéjàUtilisée',{"email":name})}}
                                    </span>
                                </li>
                            </ul>

                          <p class="help is-italic has-text-grey-light mt-2 is-info has-text-left" id="">{{$t('vousPouvezInvitezJsuquàXUSers', {'nbUsers':100})}} ({{$t('selonVotreAbonnement')}})</p>

                        </div>

                    </form>

                </div>

            </section>

            <footer class="modal-card-foot">
                <a v-on:click="hideModal()" class="button is-text cancelLink">{{$t("annuler")}}</a>
                <a v-on:click="validateBeforeSubmit()" v-bind:class="{'is-loading':isSubmiting}" v-bind:disabled="isSubmiting" class="button is-primary validBtn " id="submitModalUserManagement" >{{$t("valider")}}</a>
            </footer>

        </div>

    </div>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import SentryMixin from "../../mixins/SentryMixin.js";
    // import SpinnerLoaderComp from "./SpinnerLoaderComp.vue";
    import GlobalErrorNotification from "../../mixins/GlobalErrorNotificationMixin.js";
    import InterceptorMixin from "../../mixins/InterceptorMixin.js";
    import MarketingAutomationMixin from "@/mixins/MarketingAutomationMixin";
    import _ from 'lodash'
    import CurrencyMixin from "@/mixins/CurrencyMixin";
    import TrackingMixin from "@/mixins/TrackingMixin";

    export default {
        name: 'ModalUserManagementComp', //utile dans vue dev tool
        mixins: [GlobalErrorNotification, SentryMixin, InterceptorMixin, MarketingAutomationMixin, CurrencyMixin, TrackingMixin],

        directives: {
        },

        components: {},

        props: {
            client : Object, // un objet client à éditer, si vide alors le composant est en mode création, sinon en mode édition
        },
        data: function () {
            return {
                locale : this.$route.params.locale,
                mode: 'creation', // String le mode dans lequel on utilise la modale : 'creation/edition'
                isVisible: false, // bool | la visibilité de la modale
                isSubmiting: false,
                rolesHierarchyList: { // un objet contenant des array de roles de l'appli (avec hierarchie)
                    user:'ROLE_USER',
                    admin:'ROLE_ADMIN',
                    owner:'ROLE_OWNER'
                },

                inviteEmailList: null, // String liste d'adresses email à inviter
                arrayEmailToInvite: [ ], // Array contenant la liste d'adresses email à inviter
                arrayEmailToInviteErrors : [], //Un array contenant la liste des emails invalides dans arrayEmailToInvite
                createFormHasBeenSubmited: false, // boolean indique si le form a été soumis au mons une fois

                apiErrorResponse: {}, // Objet // Copie de la réponse retournée par l'api en cas d'erreur 400 (sert à afficher des messages d'erreur en cas de tentative d'invitation d'users déja existants)

                // NOTE : GARDER  newUser SYNCHRO AVEC resetUser() !
                newUser: // L'objet du nouveau client à créer
                    {
                        name: null , // {String} | le nom de l'utilisateur
                        firstname: null , // {String} | le prénom de l'utilisateur
                        email: null , // {String} | l'mail de l'utilisateur
                        isActive: false, // {Bool} si false l'utilisateur est désactivé
                        roles: [], // Array de roles
                        hourRate: null, // int le taux horaire de l'utilisateur
                    },
                currency:this.$auth.getActiveWorkspaceCurrency(),

                // pour les composants où l'user est identifié ///////////////////////
                organizationSlug: this.$route.params.organization
                // =================================================================
            }
        },

        computed:{
            // computed props for store :
            ...mapState({
                user: state => state.user,
                organization: state => state.organization,
                themeToDisplay: state => state.app.themeToDisplay
            }),


        },

        methods: {

            /*
            * Affiche la modale
            */
            showModal(){
                this.isVisible = true
            },

            /*
            * Masque la modale
            */
            hideModal(){
                this.isVisible = false
                this.isSubmiting=false
                this.resetUser()
            },

            /**
             * Définit toute les propriété de l'objet passé à null
             *
             * Cette sert lorsque l'on ferme la modal puis qu'on la ré-ouvre évite que les informations de l'ouverture précédente restent affichées.
             */
            resetUser(){
                this.newUser.name = null
                this.newUser.firstname = null
                this.newUser.email = null
                this.newUser.isActive = false
                this.newUser.isActive = false
                this.newUser.roles = []
                this.inviteEmailList = null

                this.arrayEmailToInviteErrors=[]
                this.arrayEmailToInvite= []
                this.apiErrorResponse= {}
            },

            /*
              Toggle la property isActive
            */
            toggleArchive() {
                if (this.newUser.isActive=== true) {
                    this.newUser.isActive= false
                } else {
                    this.newUser.isActive= true
                }
            },


            /**
             * Valide le form avant soumission
             **/
            validateBeforeSubmit(){

                let self =this;
                this.$validator.validateAll().then((result) => {
                    if (result) { // si la validation. réussie
                        switch (self.mode) {
                            case  'creation':

                                self.createFormHasBeenSubmited = true;

                                // Validation des adresses emails (car il n'y a pas de validation via vee-validate
                                self.arrayEmailToInviteErrors = []
                                self.splitInviteEmailList()

                                if(self.arrayEmailToInviteErrors.length==0){
                                    self.sendCreateQuery()
                                }
                                break;
                            case 'edition':
                                self.sendEditQuery()
                                break;
                        }
                    }
                    else{ // si il y a des erreurs...
                        self.$store.commit('UpdateGlobalNotificationComp', {
                            'isVisible': true,
                            'color': 'is-danger',
                            'message': self.$t('leFormulaireContientDesErreurs'),
                            'duration':3200
                        });
                    }

                })
            }

            /**
             * Envoie la requête d'invitation d'utilisateurs
             * @return {Promise<{} | never>}
             */
            ,sendCreateQuery(){

                this.isSubmiting = true;

                let self = this
                return self.$http
                    .post(`/organizations/${self.organizationSlug}/invit-users`,
                        {

                            users: self.arrayEmailToInvite,
                            workspace: self.$auth.getActiveWorkspace()
                            //@todo dynamiser dans #290 https://gitlab.com/ousmane1/kronocloud/-/issues/290

                        },
                        {headers: {Authorization: self.$auth.header()}}
                    )
                    .then(function (response) {
                        // calcul nombre invitation
                        let nbInvitation = _.size(response.data["users_created"])

                        // on envoie un event pour dire au UserListCom de recharger les users
                        self.$root.$emit('new_user_invited')
                        self.ga4GlobalEventTrack('Invitation' , {"number": nbInvitation})

                        self.$mixpanel.track("users invited", {"number": nbInvitation});
                        self.ga4GlobalEventTrack('Users invited' , {"number": nbInvitation})

                        self.hideModal()

                        // enregistrement via Mautic
                        self.replicateInvitUsers(self, response.data);

                        // tracking mixpanel
                        self.$mixpanel.track("users invited", {"users":self.inviteEmailList}); //@todo à priori self.inviteEmailList est vide !! à coriger

                        self.$store.commit('UpdateGlobalNotificationComp', {
                            'isVisible': true,
                            'color': 'is-success',
                            'message': self.$tc("xUtilisateursOntEteInvites", nbInvitation),
                            'duration':3200
                        });

                        return {}
                    })

                    .catch(function (error) {
                        // si l'api retourne une erreur 400 (ex users already exist) on la copie pour l'afficher localisée dans l'UI
                        if(error.response.status == 400 ){
                            self.apiErrorResponse =error.response.data;
                        }

                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        else if(self.shouldBeIntercepted(error.response,self.$auth) === false){
                          if (error.response.status === 402) {
                            self.$root.$emit('show_modal_premium_limitation','limit',
                                self.$t('LimiteAtteinte')+'...',
                                self.$tc('VotreAboVousPermetDinviterEncoreXCollabo' ,error.response.data.details.remaining,{userInWorkspace:error.response.data.details.userInWorkspace, countToInvit:error.response.data.details.countToInvit, userMax:error.response.data.details.userMax}) + '<br><br> '+
                                self.$t('VousAvezBesoinDInviterDavantageDeCollab'),
                                self.$t('MettezVotreAboÀNiveauVersPlusOuMax')
                            );

                            //@tracking
                            let trackingLabel ='Premium limitation modal displayed'
                            self.ga4GlobalEventTrack(trackingLabel, {})

                            self.$mixpanel.track(trackingLabel, {"feat":error.response.data.feat})
                          }
                          else{
                            self.logToSentry(self, error, 'error')

                            let errorCode = '0041'
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$gtag.exception({'description': 'error '+errorCode + ' | error inviting users', 'fatal': false})

                            self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error inviting users"})
                            self.$sentry.captureMessage(`Error ${errorCode} > error inviting users : ${error}`, 'error')
                          }

                        }
                    })
                    .then(function () {
                        self.isSubmiting = false;
                    })
            }

            /**
             *
             * Retourne true ou false selon que email est une adresse e-mail valide ou non
             * Inspiré de https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
             * **/
            ,emailIsValid(email) {
                const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                // si email invalide
                if(re.test(String(email).toLowerCase()) ){
                    return true
                }
                else {
                    return  false
                }

            }


            /**
             *
                Transforme la string contenant la liste d'adresses email (séparés par des sauts de ligne ou espace ou virgules- en un array.
             * */
            ,splitInviteEmailList(){

                // Trim de la liste d'email
                this.inviteEmailList= this.inviteEmailList.trim()

                // split de la string sur les virgules et espace blancs
                let splitted = this.inviteEmailList.split(/[\s,]+/)


                // formattage du payload "users"
                let usersPayload = []
                let self  = this
                _.forEach(splitted, function (data) {

                        usersPayload.push({"email":data})

                    // si l'adresse email n'est pas valide on la push dans arrayEmailToInviteErrors
                    if(!self.emailIsValid(data)){
                        self.arrayEmailToInviteErrors.push(data);
                    }

                });

                this.arrayEmailToInvite = usersPayload;

            }



            /**
             * Envoie la requête patch de modification d'un client
             * @return {Promise<{} | never>}
             */
            ,sendEditQuery(){
                this.isSubmiting = true;

                const params = {}
                    //  pour le backend envoyer firstname/name à null déclenche la validation, on retire donc ces propriété des paramètres lorsque l'on veut pouvoir patcher un user sans firsname/name
                  if(this.newUser.name != null){params.name= this.newUser.name;}
                  if(this.newUser.firstname != null){params.firstname= this.newUser.firstname;}

                  params.email= this.newUser.email,
                  params.isActive= this.newUser.isActive,
                  params.roles=this.newUser.roles,
                  params.hourRate= this.newUser.hourRate

                let self = this
                return self.$http
                    .patch(`/organizations/${self.organizationSlug}/users/${self.newUser.slug}`,
                         params,
                        {headers: {Authorization: self.$auth.header()}}
                    )
                    .then(function (response) {
                        self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                        // on envoie un event pour dire au UserListComp de maj les users
                        self.$root.$emit('user_edited',response.data)

                        self.hideModal()

                        // tracking
                        self.$mixpanel.track("User edited", {"timerecord":response.data.slug});
                        self.ga4GlobalEventTrack('User edited' , {})

                      self.$store.commit('UpdateGlobalNotificationComp', {
                        'isVisible': true,
                        'color': 'is-success',
                        'message': self.$t('modificationEnregistrée'),
                        'duration':3200
                      });

                        return {}
                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if(self.shouldBeIntercepted(error.response,self.$auth) === false){
                            self.logToSentry(self, error, 'error')

                            let errorCode = '0040'
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$gtag.exception({'description': 'error '+errorCode + ' | error editing user', 'fatal': false})

                            self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error editing user"})
                            self.$sentry.captureMessage(`Error ${errorCode} > error editing user : ${error}`, 'error')
                        }
                    })
                    .then(function () {
                        self.isSubmiting = false;
                    })
            }


            /**
             * Retourne le role le plus haut (dans la hiérarchie) de newUser
             * @param newUser
             * @return {string[]}
             */
            ,getHighestRole(newUser){
                if (newUser.roles.includes('ROLE_OWNER')) {
                    return 'ROLE_OWNER'
                }
                else if (newUser.roles.includes('ROLE_ADMIN')) {
                    return 'ROLE_ADMIN'
                }
                else if (newUser.roles.includes('ROLE_USER')) {
                    return 'ROLE_USER'
                }

            },




        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {
            /*
             * Event show_modal_user_management, déclenche l'affichage de la modale
             * @param mode String (edition/creation)
             * @param user L'objet user (dans le cas du mode edition)
             */
            this.$root.$on('show_modal_user_management', (mode, user) => {


                this.mode = mode // on définit le mode de la modale

                switch (mode) {
                    // mode creation pré-remplissage du nom du client
                    case  'creation': {

                        if (user != null) {
                            this.newUser.name = user.name
                        }
                        break;
                    }
                    // mode edition : hydratation de la modal avec le user à modifier
                    case 'edition': {

                        // ici on clone l'objet user (sinon altère le clientuserle UserListComp)
                        let clone = _.clone(user)
                        this.newUser = clone

                    }
                        break;
                }

                this.showModal()
            })


        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../../assets/css/globalVar.scss";
    /*@import "../assets/css/bulmaResponsiveDep.scss";*/

    #ModalUserManagementComp{

      .warningNotYetVerified{
        //border: dashed 1px $brandYellow;
        text-align: center;
        //padding: .4rem 1rem;
        color: $brandYellow;
        margin-bottom: 1rem;
        font-size: .8rem;
        .icon{
          vertical-align: middle;
          margin-right: .5rem;
        }
      }

      .modal-card-head .icon{
          margin-right: 0.5rem;
          color: $brandFourth;
      }
      .field{
          margin-bottom: 1.5rem;
      }

      .label{
          margin-bottom:0;
      }
      .help{
          margin-top: 0
      ;}

      .settingsZone{

          label{
              margin-bottom:  0.5rem;
              /*text-transform: low;*/
              .indicator{
                  font-size: 1rem;
              }
          }
      }
      .blocPrivacy{

      }

      .accessField {
          .icon {
              height: 1.1rem;
              margin-top: 0.3rem;
          }

        select{
            option {text-transform: uppercase; }
        }
    }
    .blocArchive{

      }

      .emailValidityError{
          list-style: disc !important;
          color: $brandRed;
          margin: 0.5rem 0;
          li{
              list-style: disc !important;
              margin: 0.5rem;
          }
      }

      .hourRateField{
        .inputAddonLabel {
          a {
            font-size: .9rem;
            padding: 1.4rem 0.8rem;
          }
        }
      }

        /////////////////////////////////////////
        // DARK THEME ///////////////////////////
        &.darkMode {

          label {
            .indicator {
              color: $darkLightBlue !important;
            }
          }

          .textarea{
            background-color: $darkBg4;
            color:$darkTxt !important;
            border-color: $darkFieldBorder;
            &::placeholder{
              color:lighten($darkFieldBorder,15%) !important;
            }
          }

          .hourRateField{
            .inputAddonLabel {
              a {
                background-color: $darkBg4 !important;
                color:#999;
                border-color: lighten($darkBg3,15%) !important;
              }
            }
          }

        }

    }
</style>
